import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  TitleStrategy,
  provideRouter,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withRouterConfig,
} from '@angular/router';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { MDS_CULTURES } from '@mds/ngx-auth';
import { provideMdsTranslationLocale } from '@mds/ngx-core';
import { provideApiApiCollectionServices } from './api/providers/api-collection-export-service.provider';
import { appRoutes } from './app.routes';
import { getConfig } from './shared/factories/config.factory';
import { provideForceLightTheme } from './shared/factories/force-lightmode.factory';
import { provideMaterial } from './shared/factories/material.factory';
import { provideNavigationItems } from './shared/factories/navigation-items.factory';
import { provideTranslations } from './shared/factories/translate.factory';
import { DEV_CONFIG } from './shared/models/config.model';
import { TranslatedTitleStrategy } from './shared/services/translated-title-strategy.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withEnabledBlockingInitialNavigation(),
      withRouterConfig({
        // This improves how canDeactivate guards work. Otherwise, pressing back
        // twice will navigate back no matter what.
        canceledNavigationResolution: 'computed',
      }),
      withComponentInputBinding(),
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideTranslations(),
    provideMdsTranslationLocale(),
    {
      provide: MDS_CULTURES,
      useValue: [
        {
          isoCode: 'en',
          name: _('Mds.Culture.English'),
          nativeName: _('Mds.Culture.NativeEnglish'),
        },
      ],
    },
    provideNavigationItems(),
    { provide: DEV_CONFIG, useFactory: getConfig },
    {
      provide: TitleStrategy,
      useClass: TranslatedTitleStrategy,
    },
    provideForceLightTheme(),
    provideMaterial(),
    provideApiApiCollectionServices(),
  ],
};
